import React from "react";
import "./dashboardCard.css";

const DashboardCard = (props) => {
  return (
    <div className="dashboard_card">
      <div className="dashboard_card_container">
        <h1>{props.main}</h1>
        <p>{props.sub}</p>
      </div>
      <svg
        width="50"
        height="50"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M57.4998 47.5C57.4998 48.163 57.2364 48.7989 56.7676 49.2678C56.2988 49.7366 55.6629 50 54.9998 50H24.9998C24.3368 50 23.7009 49.7366 23.2321 49.2678C22.7632 48.7989 22.4998 48.163 22.4998 47.5C22.4998 43.5218 24.0802 39.7064 26.8932 36.8934C29.7063 34.0804 33.5216 32.5 37.4998 32.5H42.4998C46.4781 32.5 50.2934 34.0804 53.1064 36.8934C55.9195 39.7064 57.4998 43.5218 57.4998 47.5ZM39.9998 10C38.022 10 36.0886 10.5865 34.4441 11.6853C32.7996 12.7841 31.5179 14.3459 30.761 16.1732C30.0041 18.0004 29.8061 20.0111 30.192 21.9509C30.5778 23.8907 31.5302 25.6725 32.9288 27.0711C34.3273 28.4696 36.1091 29.422 38.0489 29.8079C39.9887 30.1937 41.9994 29.9957 43.8267 29.2388C45.6539 28.4819 47.2157 27.2002 48.3145 25.5557C49.4133 23.9112 49.9998 21.9778 49.9998 20C49.9998 17.3478 48.9463 14.8043 47.0709 12.9289C45.1955 11.0536 42.652 10 39.9998 10ZM17.4998 10C15.522 10 13.5886 10.5865 11.9441 11.6853C10.2996 12.7841 9.0179 14.3459 8.26102 16.1732C7.50415 18.0004 7.30611 20.0111 7.69197 21.9509C8.07782 23.8907 9.03022 25.6725 10.4287 27.0711C11.8273 28.4696 13.6091 29.422 15.5489 29.8079C17.4887 30.1937 19.4994 29.9957 21.3267 29.2388C23.1539 28.4819 24.7157 27.2002 25.8145 25.5557C26.9133 23.9112 27.4998 21.9778 27.4998 20C27.4998 17.3478 26.4463 14.8043 24.5709 12.9289C22.6955 11.0536 20.152 10 17.4998 10ZM17.4998 47.5C17.4961 44.874 18.0135 42.2734 19.0219 39.8488C20.0304 37.4242 21.5099 35.2238 23.3748 33.375C21.8487 32.7988 20.2311 32.5024 18.5998 32.5H16.3998C12.7153 32.5066 9.18366 33.9732 6.57833 36.5785C3.97301 39.1838 2.50643 42.7155 2.49982 46.4V47.5C2.49982 48.163 2.76321 48.7989 3.23205 49.2678C3.70089 49.7366 4.33678 50 4.99982 50H17.9498C17.6588 49.1983 17.5066 48.3529 17.4998 47.5Z"
          fill="#171B1E"
        />
      </svg>
    </div>
  );
};

export default DashboardCard;
